/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     消息中心
  | @Version:   2020-01-08  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from "@/utils/request";

export function messageListApi (params) {
  return request({
    url: "?c=message&a=message&do=list",
    method: "get",
    params
  });
}

export function messageStatApi (params) {
  return request({
    url: "?c=message&a=message&do=stat",
    method: "get",
    params
  });
}

export function getMessageApi (params) {
  return request({
    url: "?c=message&a=message&do=get",
    method: "get",
    params
  });
}

export function readMessageApi (data) {
  return request({
    url: "?c=message&a=message&do=read",
    method: "post",
    data
  });
}
export function allReadMessageApi (data) {
  return request({
    url: "?c=message&a=message&do=readall",
    method: "post",
    data
  });
}
